import lessRequire from '../../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { formatMoney } from '../../../../shared/format';
import { getCurrencyIcon } from '../../../../../../shared/js/get-currency-icon';
import { mapTableSortHeaders, showMoreRows, notFound } from '../../../../shared/table-helpers';

import { getSids } from './';
import endpoints from '../../../../../config/endpoints';

import { enum as conversionStatuses } from '../../../../../../../enums/conversion-statuses';
import { enum as conversionTypes } from '../../../../../../../enums/conversion-types';

import Player from '../../../../shared/player';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import _upperFirst from 'lodash/upperFirst';

lessRequire('modules/statistics/components/table/conversions/main.less');

const Table = ({
	dataTable,
	tableRows,
	cancellationReasonsList,
	conversionStatusesList,
	gendersList,
	isCanNotMoveToNext,
	sortByColumn,
	toggleDetails,
	togglePlayer,
	showMore,
	intl
}) => {
	const { tableHeaders, detailsIndex, isPlayed, columnSorting } = dataTable;
	return (
		<table className="dashboard-table goals-table">
			<thead className="dashboard-table__head font-proxima-nova-semibold">
				<tr>
					{mapTableSortHeaders({
						headers: tableHeaders,
						columnSorting,
						sortByColumn,
						intl
					}).map((header, i) => <th key={i}>{header}</th>)}
				</tr>
			</thead>

			<tbody className="dashboard-table__body">
				{getRows(
					tableRows,
					detailsIndex,
					isPlayed,
					cancellationReasonsList,
					conversionStatusesList,
					toggleDetails,
					togglePlayer,
					gendersList,
					intl
				)}
				{!isCanNotMoveToNext && tableRows.length && showMore ? showMoreRows(showMore, 'ConversionsTable', intl) : null}
			</tbody>

		</table>
	);
};

Table.propTypes = {
	dataTable: PropTypes.object,
	tableRows: PropTypes.array,
	cancellationReasonsList: PropTypes.array,
	conversionStatusesList: PropTypes.array,
	isCanNotMoveToNext: PropTypes.bool,
	sortByColumn: PropTypes.func,
	toggleDetails: PropTypes.func,
	togglePlayer: PropTypes.func,
	showMore: PropTypes.func,
	gendersList: PropTypes.array,
	intl: PropTypes.func
};

export default Table;

const getRows = (
	rows,
	detailsIndex,
	isPlayed,
	cancellationReasonsList,
	conversionStatusesList,
	onToggleDetails,
	togglePlayer,
	gendersList,
	intl
) => {
	const elements = [];

	isEmpty(rows) && elements.push(notFound(intl));

	rows &&
		rows.forEach((row, i) => {
			const shouldShowDetails = i === detailsIndex;
			const country = row.country || '-';
			const ip = row.ip ? `\n${row.ip}` : '';

			elements.push(
				<tr key={i} className={shouldShowDetails ? 'details-opened' : ''}>
					<td className="date">
						<span>{moment(row.date).format('DD.MM.YYYY')}</span>
						<span className="secondary">{moment(row.date).format('HH:mm')}</span>
					</td>
					<td className="id">
						<span className="id__value">{row.id}</span>
					</td>
					<td className="sid">
						<span className="sid__value" title={getSids(row) || '-'}>{getSids(row) || '-'}</span>
					</td>
					<td>
						<span className="offers">{row.offer || '-'}</span>
					</td>
					<td className="goals-location">
						<span className="country-wrap">
							<span className={`flag-icon flag-icon-${row.country_code ? row.country_code.toLowerCase() : 'unknown'}`}
								title={country + ip}/>
						</span>
					</td>
					<td className='contacts'><span className="contacts__value">{row.contacts || '-'}</span></td>
					<td className="status-wrap">
						{getStatus(row, cancellationReasonsList, intl)}
					</td>
					<td className='details-wrap'>
						<span className="revenue">
							{formatMoney(row.payout, true)} <span className="currency">{getCurrencyIcon(row.currency)}</span>
						</span>
						<a
							href="#"
							className="details"
							onClick={e => {
								e.preventDefault();
								onToggleDetails(i);
							}}
						/>
					</td>
				</tr>
			);

			shouldShowDetails && elements.push(getDetailRow(
				row, detailsIndex, isPlayed, conversionStatusesList, togglePlayer, gendersList, intl));
		});

	return elements;
};

const getDetailRow = (row, index, isPlayed, conversionStatusesList, togglePlayer, gendersList, intl) => {
	const gender = find(gendersList, {id: row.client_gender });
	const status = find(conversionStatusesList, { id: row.status });
	return (
		<tr className="details-wrap" key={'detailsIndex-' + index}>
			<td colSpan="8">
				<div className="details-wrap__container clearfix">
					<div className="details-wrap__container-left">
						<span className="title icon-conversions font-proxima-nova-semibold">{intl('Детали конверсии')}</span>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Поток')}</span>
							<span className="value">{row.campaign || '-'}</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('id потока')}</span>
							<span className="value">{row.campaign_id || '-'}</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text sid-no-select">SID</span>
							<span className="value">{getSids(row) || '-'}</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Лендинг')}</span>
							<span className="value">{row.landing || '-'}</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Транзитная страница')}</span>
							<span className="value">{row.transit || '-'}</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Гео')}</span>
							<span className="value">{ row.country || '-' }</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('IP')}</span>
							<span className="value">{ row.ip || '-' }</span>
						</div>
					</div>
					<div className="details-wrap__container-right">
						<span className="title icon-phone font-proxima-nova-semibold">{intl('Детали прозвона')}</span>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Статус')}</span>
							<span className="value">
								{ row.status && capitalize(status && status.text) || '-' }
							</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Количество звонков')}</span>
							<span className="value">{row.calls_count || '-'}</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Дата первого звонка')}</span>
							<span className="value">
								{row.first_called_at
									? moment(row.first_called_at).format(`DD.MM.YYYY`) +
											' ' + intl('в') + ' ' +
											moment(row.first_called_at).format(`HH:mm:ss`)
									: '-'}
							</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Дата изменения статуса')}</span>
							<span className="value">
								{row.status_changed_at
									? moment(row.status_changed_at).format(`DD.MM.YYYY`) +
											' ' + intl('в') + ' ' +
											moment(row.status_changed_at).format(`HH:mm:ss`)
									: '-'}
							</span>
						</div>
						<div className="details-wrap__container-item">
							<span className="text">{intl('Возраст / пол')}</span>
							<span className="value">{ row.client_age || '-' } / { gender && gender.text || '-' }</span>
						</div>
						{row.record
							? <div className="details-wrap__container-record" >
								{
									<div onClick={(e) => {togglePlayer();}} className="button-record">
										{
											isPlayed ?
												<span className="close-audio-player-btn"></span>
												:
												<span className="play-audio-player-btn"></span>
										}
									</div>
								}
								{isPlayed ? <Player
									src={`${endpoints.APP.REFUSE_RECORD}/${row.id}`}
								/>: null}
							</div>
							: null }
					</div>
				</div>
			</td>
		</tr>
	);
};

const getStatus = (row, cancellationReasonsList, intl) => {
	const elements = [];
	const callsCount = row.calls_count > 0 && row.calls_count;

	switch (row.status) {
		case conversionStatuses.approved:
			elements.push(
				<span key={1} className="status active">{intl('Подтверждено')} {callsCount ? `(${callsCount})` : null}</span>
			);
			break;
		case conversionStatuses.rejected:
			elements.push(
				<span key={2} className="status inactive">{intl('Отклонено')} {callsCount ? `(${callsCount})` : null}</span>
			);
			break;
		case conversionStatuses.trash:
			elements.push(<span key={3} className="status invalid">{intl('Невалидный')}</span>);
			break;
		default:
			elements.push(
				<span key={4} className="status processing">{intl('В обработке')} {callsCount ? `(${callsCount})` : null}</span>
			);
	}

	if (row.type_id === conversionTypes.ApprovedRejected && row.status === conversionStatuses.approved) {
		elements.push(
			<div key={5} className="hint secondary">
				{intl('Подтвержденная отмена')}
			</div>
		);
	} else {
		elements.push(
			<div key={5} className="hint secondary">
				{(find(cancellationReasonsList, { id: _upperFirst(row.cancellation_reason) }) &&
					find(cancellationReasonsList, { id: _upperFirst(row.cancellation_reason) }).text) ||
					''}
			</div>
		);
	}

	return elements;
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/table/conversions/main.js